var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.75 18H26V15C26 11.691 23.309 9 20 9C16.691 9 14 11.691 14 15V18H13.25C12.01 18 11 19.009 11 20.25V30.75C11 31.991 12.01 33 13.25 33H26.75C27.99 33 29 31.991 29 30.75V20.25C29 19.009 27.99 18 26.75 18ZM16 15C16 12.794 17.794 11 20 11C22.206 11 24 12.794 24 15V18H16V15ZM21 25.722V28C21 28.552 20.553 29 20 29C19.447 29 19 28.552 19 28V25.722C18.405 25.375 18 24.737 18 24C18 22.897 18.897 22 20 22C21.103 22 22 22.897 22 24C22 24.737 21.595 25.375 21 25.722Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.aa6fa9326845b499cbc7d2a5e59d7d12.svg";
export { ForwardRef as ReactComponent };